import { SiteRoutes, matchSiteRoute } from '@/views/site/siteRoutes'

type HelpLang = 'en' | 'fr'

interface LocalizedUrl {
    en: string
    fr: string
}

/**
 * Root of the AGRID help center (Notion). Used as a fallback when the current
 * page has no dedicated article. These are the two database views the help
 * button has always pointed to.
 */
export const HELP_CENTER_ROOT: LocalizedUrl = {
    fr: 'https://iodized-fisherman-e9c.notion.site/34ce7a2bcfa380a0b52fe4943b8b0c28?v=34ce7a2bcfa38187b137000c532cd1da',
    en: 'https://iodized-fisherman-e9c.notion.site/215e7a2bcfa3808097b5f40b0af6d27a?v=215e7a2bcfa381a3bcdb000ce21756c5&source=copy_link',
}

/**
 * Page-specific help articles, keyed by the active site route. Add an entry here
 * to point the Help button at a dedicated article for that page.
 */
const SITE_ROUTE_HELP: Partial<Record<SiteRoutes, LocalizedUrl>> = {
    // "Pilotage" page -> Order a command from the dashboard interface
    [SiteRoutes.REALTIME]: {
        en: 'https://iodized-fisherman-e9c.notion.site/Order-a-command-from-the-dashboard-interface-215e7a2bcfa381879134cdae59d7f850',
        fr: 'https://iodized-fisherman-e9c.notion.site/Passer-une-consigne-depuis-l-interface-34ce7a2bcfa38139aa58c2ec4e0d5417',
    },
    // "Configuration" page -> Set or adjust temperature limits
    [SiteRoutes.CONSTRAINTS]: {
        en: 'https://iodized-fisherman-e9c.notion.site/Set-or-adjust-temperature-limits-215e7a2bcfa3814bbc86ea04d7de3ff3',
        fr: 'https://iodized-fisherman-e9c.notion.site/Comment-modifier-les-temp-ratures-minimales-et-maximales-autoris-es-34ce7a2bcfa38154a112d68a49a76d0a',
    },
}

/**
 * Returns the most relevant help-center URL for the current location.
 * Falls back to the help-center root when the current page has no dedicated article.
 */
export function getHelpUrl(pathname: string, language?: string): string {
    const lang: HelpLang = language === 'en' ? 'en' : 'fr'
    const siteRoute = matchSiteRoute(pathname)
    const pageHelp = siteRoute ? SITE_ROUTE_HELP[siteRoute] : undefined
    return (pageHelp ?? HELP_CENTER_ROOT)[lang]
}
